export default __webpack_public_path__ + "static/media/pieGraph.baec0b29.png";